import './BarGaugeVisualization.scss';

export { schema, uiSchema, getSchema } from '../../schemas/BarGaugeVisualizationSchema';

export { default } from './BarGaugeVisualization';
